import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../../assets/promiseFrame/268V_Icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-b2bf3042")

_pushScopeId("data-v-b2bf3042")
const _hoisted_1 = { class: "headTip" }
const _hoisted_2 = { class: "topText" }
const _hoisted_3 = { class: "topText_flex" }
const _hoisted_4 = {
  key: 0,
  class: "brandlogo_wrapper"
}
const _hoisted_5 = { class: "topText_one" }
const _hoisted_6 = {
  key: 1,
  class: "topText_xny"
}
const _hoisted_7 = { class: "ptb5" }
const _hoisted_8 = {
  key: 0,
  class: "productname_wrapper productname_bg"
}
const _hoisted_9 = { class: "topText_small" }
const _hoisted_10 = { class: "topText_small" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "topText_small_shallow" }, "*车型信息仅供参考，请以实车为准", -1)
const _hoisted_12 = { class: "head_promise_result_wrap" }
const _hoisted_13 = { class: "head_promise_wrapper" }
const _hoisted_14 = { class: "vector_description" }
const _hoisted_15 = { class: "result_wrap" }
const _hoisted_16 = { class: "resBox_top" }
const _hoisted_17 = { class: "top_level" }
const _hoisted_18 = { class: "top_levelDes" }
const _hoisted_19 = { class: "resbox_bottom" }
const _hoisted_20 = { class: "rectangle_resBox" }
const _hoisted_21 = { class: "rectangle_resBox_item" }
const _hoisted_22 = { class: "rectangle_resBox_item_txt" }
const _hoisted_23 = { class: "rectangle_resBox_item" }
const _hoisted_24 = { class: "rectangle_resBox_item_txt" }
const _hoisted_25 = { class: "rectangle_resBox_item" }
const _hoisted_26 = { class: "rectangle_resBox_item_txt" }
const _hoisted_27 = { class: "result_bottom" }
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  class: "localIcon",
  src: _imports_0
}, null, -1)
const _hoisted_29 = { class: "toc_ui__headTip_content_report_num" }
const _hoisted_30 = { class: "buyCarTip" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.getData('brandLogo'))
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("img", {
                  src: _ctx.getData('brandLogo'),
                  class: "topText_brandlogo"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.getData('brandName')), 1),
          (_ctx.getData('energyType') === '2')
            ? (_openBlock(), _createBlock("div", _hoisted_6, "新能源"))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_7, [
            (_ctx.getData('detectItem'))
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("span", {
                    class: "productname_font productname",
                    text: _ctx.getData('detectItem')
                  }, _toDisplayString(_ctx.getData("detectItem")), 9, ["text"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.getData("modelName")), 1),
        _createVNode("div", _hoisted_10, "VIN: " + _toDisplayString(_ctx.getData("VIN")), 1),
        _hoisted_11
      ]),
      _createVNode("div", _hoisted_12, [
        (_ctx.state.showProtect)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "head_promise_bg head_promise_bg_299",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setShowProtect()))
            }, [
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("img", {
                    class: "vector",
                    src: require('../../../../../assets/promiseFrame/headVector.png'),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("span", {
                    class: "promiseMsg head_promise_font_299",
                    text: _ctx.state.promiseTxt
                  }, _toDisplayString(_ctx.getData('serviceOneTitleH5')) + " | " + _toDisplayString(_ctx.getData('serviceTwoTitleH5')), 9, ["text"])
                ]),
                _createVNode("img", {
                  class: "headArrowRight",
                  src: require('../../../../../assets/promiseFrame/headArrowRight.png'),
                  alt: ""
                }, null, 8, ["src"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: ["head_result_bg", {'head_result_sf_bg': _ctx.state.showProtect,
                'head_result_sf_bg_noguarantee result_bg_nosf': !_ctx.state.showProtect}]
        }, [
          _createVNode("div", _hoisted_15, [
            _createVNode("div", {
              class: ["result_middle", {"result_middle_nosf": !_ctx.state.showProtect}]
            }, [
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("img", {
                    class: "levelIcon",
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('rank')}.png`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("img", {
                    class: "jiIcon",
                    src: require('../../../../../assets/promiseFrame/ji.png')
                  }, null, 8, ["src"])
                ]),
                _createVNode("div", _hoisted_18, _toDisplayString(_ctx.getData('rankDesc')), 1)
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("ul", _hoisted_20, [
                  _createVNode("li", _hoisted_21, [
                    _createVNode("img", {
                      src: require(`../../../../../assets/promiseFrame/${_ctx.getData('accidentFlag', 'additionUrl')}`),
                      alt: ""
                    }, null, 8, ["src"]),
                    _createVNode("p", _hoisted_22, _toDisplayString(_ctx.getData('accidentFlag')), 1)
                  ]),
                  _createVNode("li", _hoisted_23, [
                    _createVNode("img", {
                      src: require(`../../../../../assets/promiseFrame/${_ctx.getData('fireFlag', 'additionUrl')}`),
                      alt: ""
                    }, null, 8, ["src"]),
                    _createVNode("p", _hoisted_24, _toDisplayString(_ctx.getData('fireFlag')), 1)
                  ]),
                  _createVNode("li", _hoisted_25, [
                    _createVNode("img", {
                      src: require(`../../../../../assets/promiseFrame/${_ctx.getData('waterFlag', 'additionUrl')}`),
                      alt: ""
                    }, null, 8, ["src"]),
                    _createVNode("p", _hoisted_26, _toDisplayString(_ctx.getData('waterFlag')), 1)
                  ])
                ])
              ])
            ], 2),
            _createVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode("span", _hoisted_29, " NO." + _toDisplayString(_ctx.getData('reportCode')) + " " + _toDisplayString(_ctx.getData('reportGenDate') ? `| ${_ctx.getData('reportGenDate').replace(/-/g,'.')}` : ''), 1)
            ])
          ])
        ], 2),
        _createVNode(_component_van_popup, {
          show: _ctx.state.showProtectModel,
          "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.showProtectModel = $event)),
          round: "",
          position: "bottom"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_30, [
              _createVNode("p", {
                class: "buyCarTipItem",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toExplain('check')))
              }, " 查看《" + _toDisplayString(_ctx.getData('serviceOneTitleH5')) + "》 ", 1),
              _createVNode("p", {
                class: "buyCarTipItem",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toExplain('auth')))
              }, " 查看《" + _toDisplayString(_ctx.getData('serviceTwoTitleH5')) + "》 ", 1),
              _createVNode("p", {
                class: "canbutton",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setShowProtect()))
              }, "取消")
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ])
  ]))
})